import React, { useState } from "react";

import {
  Button,
  Flex,
  Img,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import {} from "@chakra-ui/react";

function TradeFilterSettingsModal({ isOpen, onClose }) {
  const [selectPlan, setSelectPlan] = useState("free");

  const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
  const inputBgColor = useColorModeValue("#fff", "#081b2e");

  const inputStyles = {
    borderRadius: "10px",
    boxShadow: "2px 2px 9px 0px #80808021",
    bg: inputBgColor,
    w: "100%",
    fontSize: ".9em",
    color: "#697C94",
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Filter Settings</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack
            flex="4"
            bg={containerBgColor}
            borderRadius={"15px"}
            p={["unset", "20px", "20px", "20px"]}
            alignItems={"center"}
            mt={["20px !important", "unset", "unset", "unset"]}
          >
            <Stack maxW="400px" w="350px" spacing={"25px"}>
              <Input
                placeholder="Enter Location"
                type="text"
                name="location"
                border="1px solid #999999"
                {...inputStyles}
              />

              <Stack direction={"row"} alignItems="center">
                <Text
                  cursor={"pointer"}
                  {...inputStyles}
                  p="15px"
                  {...(selectPlan === "free" ? inputStyles : {})}
                  fontSize="initial"
                  color={selectPlan === "free" && "#fff"}
                  bg={selectPlan === "free" && "grey"}
                  onClick={() => setSelectPlan("free")}
                >
                  Free
                </Text>
                <Text
                  {...inputStyles}
                  p="15px"
                  cursor="pointer"
                  {...(selectPlan === "free" ? inputStyles : {})}
                  fontSize="initial"
                  color={selectPlan === "paid" && "#fff"}
                  bg={selectPlan === "paid" && "grey"}
                  onClick={() => setSelectPlan("paid")}
                  fontWeight="medium"
                >
                  Paid
                </Text>
              </Stack>
            </Stack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default TradeFilterSettingsModal;
